export default function LiquidationHistoryHeaderList() {
  return (
    <>
      <th className="table-list-cell align-left">Market</th>
      <th className="table-list-cell align-left">Price</th>
      <th className="table-list-cell align-left">Size</th>
      <th className="table-list-cell align-left">Fund transfer</th>
      <th className="table-list-cell align-left">Liquidation fee</th>
      <th className="table-list-cell align-right">Time</th>
    </>
  )
}
